import Pagination from "rc-pagination";
import "rc-pagination/assets/index.css";
import { useState } from "react";
export default function VisitReport({ visitList }) {
  const [page, setPage] = useState(1);
  const date = (TimeStamp) => {
    let options = { year: "numeric", month: "numeric", day: "numeric" };
    let date = new Date(parseInt(TimeStamp) * 1000).toLocaleDateString("fa-IR", options);
    date.replace(/([۰-۹])/g, (token) => String.fromCharCode(token.charCodeAt(0) - 1728));
    return date;
  };

  return (
    <div class="tab-pane fade " id="view-report">
      <div className="view-report-container">
        <div className="view-report-item">
          <div className="user-management-container text-center">
            {visitList.slice((page - 1) * 5, (page - 1) * 5 + 5).map((value, index) => {
              return (
                <div className={`card-item-tabs d-flex flex-wrap ${index % 2 !== 0 && "is-dark-blue"}`}>
                  <div>
                    <div className="title">عنوان صفحه</div>
                    <div className="description">{value.title}</div>
                  </div>
                  <div>
                    <div className="title">آدرس صفحه</div>
                    <div className="description">{value.route}</div>
                  </div>
                  <div>
                    <div className="title">زمان بازدید</div>
                    <div className="description">{date(value.mtm)}</div>
                  </div>
                </div>
              );
            })}
            <div className="mx-auto text-center mt-4">
              <Pagination
                total={visitList.length}
                pageSize={5}
                current={page}
                onChange={(val) => {
                  setPage(val);
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
